import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AgGridReact } from 'ag-grid-react'; // the AG Grid React Component
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import apiServices from '../../services/service';
import Loader from '../../shared/component/Loader';
import GridSkeleton from '../../shared/component/GridSkeleton';
import LeadsColumns from '../leads/LeadsColumns';
import LeadsFilters, {
  buildAgFilterModel,
  defaultCond,
  condActive,
  ActiveFilterBar,
} from '../leads/LeadsFilters';
import {
  getAccountList,
  getActiveOwners,
  getCampaignDropdownContact,
  getContactList,
  getGenericMasterFilteredListByKey,
  getGridDataByModuleKey,
  getTagsByModule,
  getUser,
} from '../../redux/selector';
import { useDispatch, useSelector } from 'react-redux';
import { isLoadingByKey } from '../../shared/controls/methods/getLoadingState';
import { fetchDataAndUpdateStore, fetchSelectedListAndAppendToModule } from '../../redux/actions';
import { Button } from 'react-bootstrap';
import {
  contactInputData,
  dropdownPayload,
  dropdownPayloadCampaignContact,
  filterParams,
  ticketInputData,
} from '../../shared/constants';
import Select from 'react-select';
import schedule from '../../assets/img/leadsform/schedule.svg';

import Tags from '../sharedChild/tags';
import MassEmail from '../leads/massEmail';
import SelectBox from '../../shared/controls/form/selectBox';
import { validationSchemaContact } from './validationSchema';
import GlobalSearch from '../sharedChild/grid/globalSearch';
import FilterHandler from '../sharedChild/grid/filterHandler';
import PaginatedDropdown from '../../shared/component/PaginatedDropdown';
import ChildTicket from '../sharedChild/childTicket';
import ticket from '../../../src/assets/img/crm_home/header/ticket.png';
import { updateGridColumnState } from '../../redux/reducer';
import useContactColumnDefs from './useContactColumnDefs';
import { columnTypes } from '../../shared/initials';
import gridOptionsConfig from '../sharedChild/grid/gridOptionsConfig';
import useFetchIfNeeded from '../../redux/useFetchIfNeeded';
import ContactsImportModal from './ContactsImportModal';
import ContactsCreateTicketModal from './ContactsCreateTicketModal';
import ContactsMassUpdateModal from './ContactsMassUpdateModal';
import ContactsChangeOwnerModal from './ContactsChangeOwnerModal';
import ContactsAddCampaignModal from './ContactsAddCampaignModal';

// const OptionButton = ({
//   handleOpenEditForm,
//   paramsValue,
//   rowData,
//   handleClickDelete,
//   handleOpenViewForm,
//   hasDeleteContactPermission,
//   hasUpdateContactPermission,
//   hasInfoContactPermission,
// }) => {
//   const [showConfirmation, setShowConfirmation] = React.useState(false);

//   const handleDeleteClick = () => {
//     setShowConfirmation(true);
//   };

//   const handleConfirmDelete = () => {
//     handleClickDelete(paramsValue);
//     setShowConfirmation(false);
//   };

//   const handleCloseConfirmation = () => {
//     setShowConfirmation(false);
//   };

//   return (
//     <div className="action-menu">
//       {hasUpdateContactPermission && (
//         <img
//           src="/assets/images/edit.png"
//           className="action-img1"
//           onClick={() => handleOpenEditForm(paramsValue)}
//           alt="Edit Contact"
//           title="Edit Contact"
//         ></img>
//       )}
//       {hasInfoContactPermission && (
//         <img
//           src="/assets/images/view.png"
//           className="action-img2"
//           onClick={() => handleOpenViewForm(paramsValue)}
//           alt="View Contact"
//           title="View Contact"
//         ></img>
//       )}
//       {hasDeleteContactPermission && (
//         <img
//           src="/assets/images/trash.png"
//           className="action-img2"
//           onClick={handleDeleteClick}
//           alt="Delete Contact"
//           title="Delete Contact"
//         ></img>
//       )}
//       <DeleteConfirmationModal
//         show={showConfirmation}
//         handleClose={handleCloseConfirmation}
//         handleConfirm={handleConfirmDelete}
//         rowData={rowData}
//       />
//     </div>
//   );
// };

// const DeleteConfirmationModal = ({
//   show,
//   handleClose,
//   handleConfirm,
//   rowData,
// }) => {
//   return (
//     <Modal show={show} onHide={handleClose} className="modal-delete">
//       {rowData && (
//         <>
//           {/* {rowData?.childAssignment?.length > 0 ? "? It will also delete sub assignment !!" : "?"} */}

//           <div className="warning-content">
//             <div className="warningOuter">
//               <div className="alertImg">
//                 <img
//                   src="../assets/images/delete-record.png"
//                   alt="Delete Record"
//                 ></img>
//               </div>
//               <div className="warningText">
//                 {" "}
//                 Are you sure you want to delete this contact
//                 <p>
//                   {" "}
//                   {rowData?.fullName}?
//                 </p>

//               </div>
//             </div>
//             <div className="notes">
//               *Note: Any associated Activities, Visits, Drafts will also be Deleted.
//             </div>
//             <div className="warningBtn">
//               <Button variant="secondary" className='btn' onClick={handleClose}>
//                 Cancel
//               </Button>
//               <Button className='btn' variant="danger" onClick={handleConfirm}>
//                 Confirm Delete
//               </Button>
//             </div>
//           </div>
//         </>
//       )}
//     </Modal>
//   );
// };

// const initialValue = {
//   // contactOwner: "",
//   // contactOwnerId: "",
//   leadSource: "",
//   leadSourceId: "",
//   // createdBySystem: "",
//   // createdBySystemId: "",
//   // modifiedBySystem: "",
//   // modifiedBySystemid: "",
//   firstName: "",
//   middleName: "",
//   lastName: "",
//   title: "",
//   email: "",
//   // secondaryEmail: "",
//   // department: "",
//   accountName: "",
//   // accountNameId: "",
//   phone: "",
//   // mobile: "",
//   // reportingTo: "",
//   // assistant: "",
//   // assistantPhone: "",
//   // emailOptOut: false,
//   // contactPersonRole: "",
//   linkedIn: "",
//   twitter: "",
//   facebook: "",
//   // skypeId: "",
//   // street: "",
//   // city: "",
//   // state: "",
//   // zipCode: "",
//   // country: "",
//   // description: "",
//   // technologyStack: "",
//   // notes: [],
//   // openActivities: [],
//   // closedActivities: [],
//   // attachments: [],
//   // deals: [],
//   // products: [],
//   // invitedMeetings: [],
//   // cases: [],
//   // quotes: [],
//   // salesOrders: [],
//   // purchaseOrders: [],
//   // emails: [],
//   // invoices: [],
//   // campaigns: [],
//   // reportingContacts: [],
// };

function Contacts() {
  const stateData = useSelector((state) => state);
  const gridData = useSelector(getGridDataByModuleKey('contactList'));

  const leadSourceList = useSelector(getGenericMasterFilteredListByKey('LeadSource'));
  const dispatch = useDispatch();
  let storeLoading = isLoadingByKey(stateData, 'contactList', 'campaignDropdownContact', 'tags');

  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const gridRef = useRef();
  const [open, setOpen] = React.useState(false);
  const rowData = useSelector(getContactList);
  const [loading, setLoading] = useState(storeLoading);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [importOpen, setImportOpen] = useState(false);
  const [ticketOpen, setTicketOpen] = useState(false);
  const [massUpdateOpen, setMassUpdateOpen] = useState(false);
  const [changeOwnerOpen, setChangeOwnerOpen] = useState(false);
  const [addCampaignOpen, setAddCampaignOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [fieldValues, setFieldValues] = useState({});
  const [ownerFieldValues, setOwnerFieldValues] = useState({});
  const [selectedOption, setSelectedOption] = useState(null);
  const [isSelectedOption, setIsSelectedOption] = useState(false);
  const [campaignData, setCampaignData] = useState([]);
  const [allcolumnList, setAllcolumnList] = useState([]);
  const [popupAction, setPopupAction] = useState('add');
  const [remindVisible, setRemindVisible] = useState(false);
  const [showReminderPage, setShowReminderPage] = useState(false);
  const [formData, setFormData] = useState([]);
  const [errormsg, setErrorMsg] = useState({});
  const [gridParams, setGridParams] = useState(null);
  const [showMassEmailPopup, setShowMassEmailPopup] = useState(false);
  const gridDataSelection = useSelector(getGridDataByModuleKey('selectionList'));
  const gridOptions = gridOptionsConfig('contactList', navigate);
  const suppressSelectionChangeRef = useRef(false);

  let hasUpdateContactPermission = true;
  let hasCreateContactPermission = true;
  let hasDeleteContactPermission = true;
  let hasInfoContactPermission = true;
  let userUIControlPermission = JSON.parse(
    localStorage.getItem('userUIControlPermission')
  )?.contactmenu;

  if (userUIControlPermission) {
    hasCreateContactPermission = userUIControlPermission?.contactaddscreen
      ? userUIControlPermission.contactaddscreen.canView
      : true;

    hasUpdateContactPermission = userUIControlPermission?.contactupdatescreen
      ? userUIControlPermission.contactupdatescreen.canView
      : true;

    hasDeleteContactPermission = userUIControlPermission?.contactdeletescreen
      ? userUIControlPermission.contactdeletescreen.canView
      : true;

    hasInfoContactPermission = userUIControlPermission?.contactinfoscreen
      ? userUIControlPermission.contactinfoscreen.canView
      : true;
  }
  const ticketPriorityDropdown = useSelector(
    getGenericMasterFilteredListByKey('TicketPriorityCrm')
  );
  const handleChangeCheckbox = (e) => {
    const { name, checked } = e.target; // Use 'checked' for true/false value

    setFieldValues((prevValues) => ({
      ...prevValues,
      [name]: checked, // Set the checkbox state as true/false
    }));
  };

  const {
    options: accountOptions,
    isLoading: isAccountLoading,
    handleSearch: handleAccountSearch,
    handleScroll: handleAccountScroll,
  } = PaginatedDropdown({
    fetchFn: apiServices.getAccountsDropdown,
    responseKey: 'accountList',
  });

  const ticketStatusDropdown = useSelector(getGenericMasterFilteredListByKey('StatusCrm'));

  const owner = useSelector(getActiveOwners);
  const userInfo = useSelector(getUser);
  const campaignListDropdown = useSelector(getCampaignDropdownContact);
  const memberStatus = useSelector(getGenericMasterFilteredListByKey('MemberStatusCrm'));
  const tagsList = useSelector(getTagsByModule('contactList'));

  const contactPersonRole = useSelector(getGenericMasterFilteredListByKey('ContactPersonRole'));
  const salutation = useSelector(getGenericMasterFilteredListByKey('Salutation'));
  const accounts = useSelector(getAccountList);

  const onSelectionChanged = (event) => {
    const gridApi = gridRef.current.api;
    const selectedRowsLocal = gridApi.getSelectedRows();
    const key = 'page-' + gridData?.inputPayload?.pageNumber;
    dispatch(
      fetchSelectedListAndAppendToModule({
        key: 'contactList',
        selectedList: { [key]: selectedRowsLocal },
      })
    );
  };

  const fullSelection = Object.values(gridDataSelection?.contactList || {}).flat();

  // GrowthOS bulk-bar: clear the current selection (grid + redux)
  const clearContactSelection = () => {
    gridRef.current?.api?.deselectAll();
    dispatch(fetchSelectedListAndAppendToModule({ key: 'contactList', selectedList: {} }));
  };

  const handleClickDelete = (paramsValue) => {
    setLoading(true);

    // Creating the desired JSON object
    let data;
    // Creating the desired JSON object
    if (paramsValue.id === undefined) {
      const selectedIds = fullSelection.map((row) => row.id);
      data = { id: selectedIds };
    } else {
      data = {
        id: [paramsValue.id],
      };
    }
    apiServices
      .deleteContact(data)
      .then((response) => {
        if (response.status === 200) {
          if (paramsValue.id === undefined) {
            document.getElementById('massDeleteModal').click();
          }
          dispatch(
            fetchSelectedListAndAppendToModule({
              key: 'contactList',
              selectedList: {},
            })
          );
          dispatch(
            fetchDataAndUpdateStore({
              key: 'contactList',
              inputData: gridData?.inputPayload ? gridData?.inputPayload : contactInputData,
            })
          );
          dispatch(
            fetchDataAndUpdateStore({
              key: 'contactDropdown',
              inputData: dropdownPayload,
            })
          );
          setLoading(false);
          toast.success('Contact Deleted Successfully!', {
            position: 'top-right',
          });
        } else {
          setLoading(false);
          toast.error('Error deleting record', {
            position: 'top-right',
          });
        }
      })
      .catch((error) => {
        console.error('Error deleting record:', error);
        setLoading(false);
      });
  };
  const columnDefs = useContactColumnDefs({
    hasUpdateContactPermission,
    hasInfoContactPermission,
    hasDeleteContactPermission,
    campaignListDropdown,
    tagsList,
    contactPersonRole,
    salutation,
    leadSourceList,
    owner,
    gridData,
    open,
    handleClickDelete,
  });

  // ---- custom Filters panel (drives AG Grid filterModel = server-side, via handleFilterChanged) ----
  const [filterConds, setFilterConds] = useState({});
  const [filterOpen, setFilterOpen] = useState(false);
  const [expandedFilter, setExpandedFilter] = useState(null);
  const filterFields = useMemo(
    () => [
      { field: 'owner', label: 'Contact Owner', type: 'set', vals: (owner || []).map((x) => x.display_name).filter(Boolean) },
      { field: 'leadSource', label: 'Lead Source', type: 'set', vals: (leadSourceList || []).map((x) => x.displayName).filter(Boolean) },
      { field: 'campaignId', label: 'Campaign', type: 'set', vals: (campaignListDropdown || []).map((x) => x.campaignName).filter(Boolean) },
      { field: 'tagIds', label: 'Tags', type: 'set', vals: (tagsList || []).map((x) => x.name).filter(Boolean) },
      { field: 'contactPersonRole', label: 'Contact Person Role', type: 'set', vals: (contactPersonRole || []).map((x) => x.name).filter(Boolean) },
      { field: 'salutation', label: 'Salutation', type: 'set', vals: (salutation || []).map((x) => x.name).filter(Boolean) },
      { field: 'account', label: 'Account', type: 'text' },
      { field: 'email', label: 'Email', type: 'text' },
      { field: 'title', label: 'Title', type: 'text' },
      { field: 'phone', label: 'Phone', type: 'text' },
      { field: 'department', label: 'Department', type: 'text' },
      { field: 'city', label: 'City', type: 'text' },
      { field: 'state', label: 'State', type: 'text' },
      { field: 'createdDateTime', label: 'Created Date', type: 'date' },
      { field: 'emailOptOut', label: 'Email Opt Out', type: 'boolean' },
    ],
    [owner, leadSourceList, campaignListDropdown, tagsList, contactPersonRole, salutation]
  );
  const applyFilterConds = useCallback(
    (c) => {
      const api = gridRef.current?.api;
      if (api) api.setFilterModel(buildAgFilterModel(c, filterFields));
    },
    [filterFields]
  );
  const setFilterCond = (field, patch) => {
    setFilterConds((prev) => {
      const meta = filterFields.find((x) => x.field === field);
      const base = prev[field] || defaultCond(meta.type);
      return { ...prev, [field]: { ...base, type: meta.type, ...patch } };
    });
  };
  const removeFilterCond = (field) => {
    setFilterConds((prev) => {
      const n = { ...prev };
      delete n[field];
      applyFilterConds(n);
      return n;
    });
    setExpandedFilter((e) => (e === field ? null : e));
  };
  const clearAllFilters = () => {
    setFilterConds({});
    applyFilterConds({});
    setExpandedFilter(null);
  };
  const hasActiveFilters = Object.values(filterConds).some(condActive);

  // ---- "Columns" show/hide menu (drives AG Grid column visibility) ----
  const [colsOpen, setColsOpen] = useState(false);
  const [hiddenCols, setHiddenCols] = useState(() => new Set());
  const columnMenuList = useMemo(
    () =>
      columnDefs
        .filter((c) => c.field && c.headerName) // skip the checkbox/actions column
        .map((c) => ({ id: c.field, label: c.headerName, locked: c.field === 'fullName' })),
    [columnDefs]
  );
  const syncHiddenCols = useCallback(() => {
    const colApi = gridRef.current?.columnApi;
    if (!colApi?.getColumnState) return;
    setHiddenCols(new Set(colApi.getColumnState().filter((c) => c.hide).map((c) => c.colId)));
  }, []);
  const toggleCol = (id) => {
    const colApi = gridRef.current?.columnApi;
    const api = gridRef.current?.api;
    const makeVisible = hiddenCols.has(id);
    if (colApi?.setColumnsVisible) colApi.setColumnsVisible([id], makeVisible);
    else if (colApi?.setColumnVisible) colApi.setColumnVisible(id, makeVisible);
    else if (api?.setColumnsVisible) api.setColumnsVisible([id], makeVisible);
    syncHiddenCols();
  };
  const toggleAllCols = () => {
    const colApi = gridRef.current?.columnApi;
    const api = gridRef.current?.api;
    const toggleable = columnMenuList.filter((c) => !c.locked).map((c) => c.id);
    if (toggleable.length === 0) return;
    const allShown = toggleable.every((id) => !hiddenCols.has(id));
    const makeVisible = !allShown;
    if (colApi?.setColumnsVisible) colApi.setColumnsVisible(toggleable, makeVisible);
    else if (api?.setColumnsVisible) api.setColumnsVisible(toggleable, makeVisible);
    syncHiddenCols();
  };

  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          minWidth: 225,
          width: 225,
          maxWidth: 225,
          toolPanelParams: {
            suppressPivotMode: true, // 👈 Hide Pivot Mode toggle
            suppressRowGroups: false, // ✅ Allow row grouping
            suppressValues: false, // ✅ Allow aggregation if needed
            suppressPivots: true, // 👈 Hide the pivot section for columns
          },
        },
        {
          id: 'filters',
          labelDefault: 'Filters',
          labelKey: 'filters',
          iconKey: 'filter',
          toolPanel: 'agFiltersToolPanel',
          minWidth: 180,
          maxWidth: 400,
          width: 250,
        },
      ].filter(Boolean),
      position: 'left',
      defaultToolPanel: 'none', //show off filter tab bydefault.
    };
  }, []);

  const popupParent = useMemo(() => {
    return document.body;
  }, []);

  const sortingOrder = useMemo(() => {
    return ['desc', 'asc', null];
  }, []);

  const defaultColDef = useMemo(() => ({
    sortable: true,
    editable: false,
    flex: 1,
    minWidth: 130,
    filter: true,
    resizable: true,
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
  }));

  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 200,
      pinned: 'left',
    };
  }, []);

  const handleOpenAddForm = () => {
    navigate('/contacts/addContact');
  };

  // const handleOpenEditForm = (paramsValue) => {
  //   navigate("/contacts/editContact", {
  //     state: paramsValue,
  //   });
  // };

  // const handleOpenViewForm = (paramsValue) => {
  //   // setViewOpen(true)
  //   navigate(`/contacts/viewContact?id=${paramsValue.id}&pageNo=${gridData?.inputPayload?.pageNumber}`, {
  //     state: paramsValue,
  //   });
  // };

  const onFirstDataRendered = useCallback((params) => {
    gridRef.current.api.paginationGoToPage();
    getAllColumns();
    syncHiddenCols();
  }, [syncHiddenCols]);

  const cellClickedListener = useCallback((event) => {}, []);
  const emailPopup = () => {
    setIsOpen(!isOpen);
    if (isMinimized) setIsMinimized(false);
  };

  const toggleMinimize = () => {
    setIsMinimized(!isMinimized);
  };

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const handleGetMassPopup = () => {
    getAllColumns();
    setFieldValues({});
    setOwnerFieldValues((prevValues) => ({
      ...prevValues,
      ownerId: userInfo.user.userId,
    }));
    // setOwnerFieldValues({"ownerId":userInfo.user.userId});
    setIsSelectedOption(false);
    setSelectedOptions(null);
  };

  const handleSelection = (selectedOption) => {
    setIsSelectedOption(true);
    // Clear previous field value
    setFieldValues({});
    if (selectedOption.originalData.headerName === 'Lead Source') {
      selectedOption.originalData.data = leadSourceList;
    } else if (selectedOption.originalData.headerName === 'Contact Owner') {
      selectedOption.originalData.data = owner;
    } else if (selectedOption.originalData.headerName === 'Contact Person Role') {
      selectedOption.originalData.data = contactPersonRole;
    } else if (selectedOption.originalData.headerName === 'Account Name') {
      selectedOption.originalData.data = accounts;
    } else if (selectedOption.originalData.headerName === 'Salutation') {
      selectedOption.originalData.data = salutation;
    } else if (selectedOption.originalData.headerName === 'Email Opt Out') {
      setFieldValues((prev) => ({
        ...prev,
        emailOptOut: false,
      }));
    }
    setSelectedOption(selectedOption); // Update the selected value in state
    console.log('Selected Option:', selectedOption); // Log the selected value
  };

  const handleInputChange = (e, fieldName) => {
    const value = e.target.value;
    // For other fields, directly update the state
    setFieldValues((prevValues) => ({
      ...prevValues,
      [fieldName]: value,
    }));
  };

  const handleDropdownChange = (selected, fieldName) => {
    const value = selected.value;
    setFieldValues((prevValues) => ({
      ...prevValues,
      [fieldName]: value,
    }));

    console.log(`Dropdown selected: ${value}`);
  };
  const closeMassEmailPopup = () => {
    setShowMassEmailPopup(false);
  };
  const handleSelectChange = (selectedOption) => {
    if (selectedOption) {
      // Format the selected data as required
      const formattedData = {
        fieldName: 'ownerId', // Static field name
        fieldValue: selectedOption.value, // The `value` from the dropdown
      };

      setOwnerFieldValues((prevValues) => ({
        ...prevValues,
        [formattedData.fieldName]: formattedData.fieldValue,
      }));
      // Log or handle the formatted JSON data
      console.log('Formatted Data:', formattedData);

      // Update the state or pass the formatted data to an API
      //setSelectedValue(formattedData);
    }
  };

  const handleChange = (selectedOption, name) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: selectedOption,
    }));
    handleLookupDropDownChange(selectedOption.value, selectedOption, name);
  };

  const handleLookupDropDownChange = (selectedId, selectedOption, name) => {
    const selectedValue = selectedOption.label;
    if (name === 'memberStatusId') {
      setCampaignData({
        ...campaignData,
        memberStatusId: selectedValue,
        memberStatus: selectedId,
      });
    } else if (name === 'campaignId') {
      setCampaignData({
        ...campaignData,
        campaignId: selectedId,
      });
    } else if (name === 'statusId') {
      setFormData({
        ...formData,
        statusId: selectedId,
        status: selectedValue,
      });
    } else if (name === 'priorityId') {
      setFormData({
        ...formData,
        priorityId: selectedId,
        priority: selectedValue,
      });
    } else if (name === 'ownerId') {
      setFormData({
        ...formData,
        ownerId: selectedId,
        owner: selectedValue,
      });
    }
  };

  const handleMassUpdate = async (selectedRowData) => {
    setLoading(true); // Set loading state when starting mass update
    let result;
    console.log('selectedRowData', selectedRowData);

    // Extract the IDs from the selectedRowData array
    const ids = selectedRowData.map((item) => item.id);

    // Check if there is at least one field to update
    if (Object.keys(fieldValues).length > 0) {
      const [fieldName, fieldValue] = Object.entries(fieldValues)[0];

      // Validate the specific field using Yup's validateAt
      try {
        await validationSchemaContact.validateAt(fieldName, {
          [fieldName]: fieldValue,
        });
      } catch (error) {
        if (error.name === 'ValidationError') {
          toast.error(`Validation error in ${fieldName}: ${error.message}`, {
            position: 'top-right',
          });
          setLoading(false); // Reset loading state on validation error
          return;
        }
      }

      result = {
        ids: ids,
        fieldName: fieldName.charAt(0).toUpperCase() + fieldName.slice(1),
        fieldValue: fieldValue.toString(),
      };
    } else {
      toast.error('No field values provided for update.', {
        position: 'top-right',
      });
      setLoading(false); // Reset loading state if no fields to update
      return;
    }

    console.log('result:', result);
    console.log('Submitted Values:', fieldValues);

    try {
      const response = await apiServices.updateMultipleContactField(result);
      if (response.status === 200) {
        document.getElementById('massUpdateCancel').click();
        toast.success('Contact Updated Successfully!', {
          position: 'top-right',
        });
        handleGetMassPopup();
        dispatch(
          fetchDataAndUpdateStore({
            key: 'contactList',
            inputData: gridData?.inputPayload ? gridData?.inputPayload : contactInputData,
          })
        );
        dispatch(
          fetchDataAndUpdateStore({
            key: 'contactDropdown',
            inputData: dropdownPayload,
          })
        );
      } else {
        setLoading(false);
        const errorMessages = [];
        for (const key in response.errors) {
          if (response.errors.hasOwnProperty(key)) {
            const messages = response.errors[key];
            errorMessages.push(...messages);
          }
        }
        errorMessages.forEach((errorMessage) => {
          toast.error(errorMessage, { position: 'top-right' });
        });
      }
    } catch (error) {
      toast.error('An unexpected error occurred.', { position: 'top-right' });
      setLoading(false);
    }
  };

  const handleOwnerUpdate = (selectedRows) => {
    setLoading(true);
    let result;
    console.log('selectedRowData', selectedRows);
    // Extract the IDs from the selectedRowData array
    const ids = selectedRows.map((item) => item.id);
    if (Object.keys(ownerFieldValues).length > 0) {
      const [fieldName, fieldValue] = Object.entries(ownerFieldValues)[0];
      result = {
        ids: ids,
        fieldName: fieldName.charAt(0).toUpperCase() + fieldName.slice(1),
        fieldValue: fieldValue,
      };
    }
    apiServices
      .updateMultipleContactField(result)
      .then((response) => {
        if (response.status === 200) {
          document.getElementById('ownerUpdateCancel').click();
          handleGetMassPopup();
          toast.success('Owner Updated Successfully!', {
            position: 'top-right',
          });
          dispatch(
            fetchDataAndUpdateStore({
              key: 'contactList',
              inputData: gridData?.inputPayload ? gridData?.inputPayload : contactInputData,
            })
          );
        } else {
          setLoading(false);
          const errorMessages = [];
          for (const key in response.errors) {
            if (response.errors.hasOwnProperty(key)) {
              const messages = response.errors[key];
              errorMessages.push(...messages);
            }
          }
          errorMessages.forEach((errorMessage) => {
            toast.error(errorMessage, { position: 'top-right' });
          });
        }
      })

      .catch((error) => {
        toast.error('An unexpected error occurred.', {
          position: 'top-right',
        });
        setLoading(false);
      });
  };

  const handleSubmit = async (campaignData) => {
    const selectedIds = fullSelection.map((row) => row.id);
    const updatedFormData = {
      ...campaignData,
      campaignId: [campaignData.campaignId],
      contactId: selectedIds,
    };
    apiServices
      .addCampaignFromContact(updatedFormData)
      .then((response) => {
        if (response.status === 200) {
          document.getElementById('closeModalButton').click();
          if (response?.data === 'No new records inserted (duplicates exist)') {
            toast.error('No new records inserted (duplicates exist)', {
              position: 'top-right',
            });
            setLoading(false);
          } else {
            setLoading(false);
            toast.success('Campaign Added successfully!', {
              position: 'top-right',
            });
          }
        } else {
          setLoading(false);
          const errorMessages = [];
          for (const key in response.errors) {
            if (response.errors.hasOwnProperty(key)) {
              const messages = response.errors[key];
              errorMessages.push(...messages);
            }
          }
          errorMessages.forEach((errorMessage) => {
            toast.error(errorMessage, { position: 'top-right' });
          });
        }
      })

      .catch((error) => {
        toast.error('An unexpected error occurred.', {
          position: 'top-right',
        });
        setLoading(false);
      });
    //  }
  };
  // Add this method to get all columns
  const getAllColumns = () => {
    const columnApi = gridRef.current.columnApi;
    const data = columnApi.api.getAllGridColumns();
    const excludedColumns = [
      'Contact Owner',
      'Lead Source',
      'Salutation',
      'First Name',
      'Middle Name',
      'Last Name',
      'Title',
      'Email',
      'Secondary Email',
      'Department',
      'Account Name',
      'Phone',
      'Mobile',
      'Reporting To',
      'Assistant',
      'Assistant Phone',
      'Contact Person Role',
      'Email Opt Out',
      'LinkedIn',
      'Twitter',
      'Facebook',
      'Skype ID',
      'Street',
      'City',
      'State',
      'Zip Code',
      'Country',
      'Description',
      'Technology Stack',
    ];
    const allColumns = data
      .map((col) => col.getColDef())
      .filter((colDef) => excludedColumns.includes(colDef.headerName));
    setAllcolumnList(allColumns);
    // const allColumns = columnApi.getAllColumns();
    console.log('All Columns:', allColumns);
  };

  // Add custom styles for Select component
  const customStyles = {
    control: (base, state) => ({
      ...base,
      border: state.isFocused ? '2px solid transparent' : '1px solid transparent',
      borderRadius: '5px',
      boxShadow: state.isFocused ? 'none' : 'none',
      ':hover': {
        borderColor: 'transparent',
      },
    }),
    placeholder: (base) => ({
      ...base,
      color: '#888',
      fontSize: '.8rem',
    }),
    indicatorsContainer: (base) => ({
      ...base,
      display: 'none',
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: '#E7F2FF',
      borderRadius: '50px',
      padding: '5px 14px',
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: '#707070',
      fontSize: '.8rem',
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: '#4caf50',
      ':hover': {
        backgroundColor: '#d32f2f',
        color: '#fff',
      },
    }),
  };

  const handleAddTag = () => {
    setPopupAction('add');
    setShowPopup(true);
  };

  // When "Remove Tags" is clicked, set mode to "remove" and show the popup
  const handleRemoveTag = () => {
    setPopupAction('remove');
    setShowPopup(true);
  };

  // Toggle the popup visibility

  const togglePopupVisibility = () => {
    setRemindVisible(!remindVisible);
    setShowReminderPage(false); // Reset to default page on close
  };

  const handleBackClick = () => {
    setShowReminderPage(false);

    setFormData((prev) => ({
      ...prev,
      showReminder: !!prev.reminder, // true if reminder exists, false otherwise
    }));
  };
  const handleDateTime = (e) => {
    const dataTime = e.target.value;
    setFormData({
      ...formData,
      reminder: dataTime,
    });
  };
  const handleReminderClick = () => {
    setShowReminderPage(!showReminderPage);
    // When turning off reminder, clear the reminder value
    if (showReminderPage) {
      setFormData({
        ...formData,
        reminder: '',
        showReminder: false,
      });
    } else {
      // When turning on, preserve existing reminder if any
      setFormData({
        ...formData,
        showReminder: true,
      });
    }
  };
  const handleFormSubmit = (formData) => {
    setLoading(true);
    const ids = fullSelection.map((item) => item.id);
    const updatedFormData = {
      ...formData,
      contactId: ids.toString(),
    };
    apiServices
      .createTicketList(updatedFormData)
      .then((response) => {
        if (response.status === 200) {
          togglePopupVisibility();
          toast.success('Ticket created successfully!');
          dispatch(
            fetchDataAndUpdateStore({
              key: 'ticketList',
              inputData: ticketInputData,
            })
          );
          setFormData([]);
          setSelectedOptions(null);
          setLoading(false);
        } else {
          setLoading(false);
          const errorMessages = [];
          for (const key in response.errors) {
            if (response.errors.hasOwnProperty(key)) {
              const messages = response.errors[key];
              errorMessages.push(...messages);
            }
          }
          errorMessages.forEach((errorMessage) => {
            toast.error(errorMessage, { position: 'top-right' });
          });
        }
      })

      .catch((error) => {
        console.error('Error:', error, 'DataFormat:', formData);
        toast.error('An unexpected error occurred.', {
          position: 'top-right',
        });
        setLoading(false);
      });
  };
  const handleChangeForm = (e) => {
    const { name, value } = e.target;
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));
    const convertedValue = value;
    setFormData({
      ...formData,
      [name]: convertedValue,
    });
  };

  const filterDefaultSetRef = useRef(null);
  const handleFilterChanged = useCallback(
    (event) => {
      if (filterDefaultSetRef.current) {
        filterDefaultSetRef.current = false;
      } else {
        let filterModel = event.api.getFilterModel();
        console.log('Original Filter Model:', filterModel);

        // Create mappings for campaign names and tag names to their IDs
        const campaignMapping = {};
        if (campaignListDropdown?.length) {
          campaignListDropdown.forEach((item) => {
            campaignMapping[item.campaignName] = item.id;
          });
        }

        const tagMapping = {};
        if (tagsList?.length) {
          tagsList.forEach((item) => {
            tagMapping[item.name] = item.id;
          });
        }

        const updatedFilterModel = Object.keys(filterModel).reduce((acc, dynamicFilterKey) => {
          let filterData = filterModel[dynamicFilterKey];

          if (dynamicFilterKey === 'campaignId') {
            // Convert campaign names to campaign IDs
            const idValues = filterData.values
              .map((name) => campaignMapping[name])
              .filter((id) => id !== undefined);

            if (idValues.length > 0) {
              acc[dynamicFilterKey] = {
                filterType: 'text',
                operator: 'OR',
                conditions: idValues.map((id) => ({
                  filterType: 'text',
                  type: 'contains',
                  filter: id, // Ensure we send ID, not name
                })),
              };
            }
          } else if (dynamicFilterKey === 'tagIds') {
            // Convert tag names to tag IDs
            const idValues = filterData.values
              .map((name) => tagMapping[name])
              .filter((id) => id !== undefined);

            if (idValues.length > 0) {
              acc[dynamicFilterKey] = {
                filterType: 'text',
                operator: 'OR',
                conditions: idValues.map((id) => ({
                  filterType: 'text',
                  type: 'contains',
                  filter: id, // Ensure we send ID, not name
                })),
              };
            }
          } else {
            acc[dynamicFilterKey] = filterData;
          }
          return acc;
        }, {});

        const payload = {
          ...gridData?.inputPayload,
          filterJson: JSON.stringify(updatedFilterModel),
          pageNumber: 1, // Reset to first page on filter change
        };

        dispatch(
          fetchDataAndUpdateStore({
            key: 'contactList',
            inputData: payload,
          })
        );
      }
    },
    [dispatch, gridData?.inputPayload, campaignListDropdown, tagsList]
  );

  const handleSortChanged = useCallback(
    (event) => {
      const sortModel = event.columnApi
        .getAllDisplayedColumns()
        .map((col) => ({
          colId: col.getColId(),
          sort: col.getSort(),
        }))
        .filter((col) => col.sort);

      console.log('Sort Model:', sortModel);
      const columnName = sortModel.length > 0 ? sortModel[0].colId : 'UpdatedDateTime';
      const orderType = sortModel.length > 0 ? sortModel[0].sort : 'desc';

      const payload = {
        ...gridData?.inputPayload,
        columnName,
        orderType,
        pageNumber: 1, // Reset to first page on sort change
      };

      dispatch(
        fetchDataAndUpdateStore({
          key: 'contactList',
          inputData: payload,
        })
      );
    },
    [dispatch, gridData?.inputPayload]
  );

  const handleColumnChanged = (params) => {
    const columnApi = gridRef.current.columnApi;
    const columnState = columnApi.getColumnState();
    dispatch(
      updateGridColumnState({
        moduleKey: 'contactList',
        columnState: columnState,
      })
    );
    syncHiddenCols();
  };

   const handleGridReady = (params) => {
    gridRef.current = params;
    setGridParams(params);
    const columnOrderFromStore = gridData?.columnState;

    if (columnOrderFromStore) {
      params.columnApi.applyColumnState({
        state: columnOrderFromStore,
        applyOrder: true,
      });
    } else {
      // apply default column visibility if no saved state
      const fieldsToHide = [
        'tagIds',
        'campaignId',
        'createdDateTime',
        'updatedDateTime',
        'secondaryEmail',
        'mobile',
        'twitter',
        'facebook',
        'reportingTo',
        'salutation',
        'lastName',
        'middleName',
        'firstName',
        'description',
        'skypeId',
        'technologyStack',
        'country',
        'city',
        'street',
        'contactPersonRole',
        'assistantPhone',
        'assistant',
      ];

      const defaultState = params.columnApi.getColumnState().map((col) => ({
        ...col,
        hide: fieldsToHide.includes(col.colId),
      }));

      params.columnApi.applyColumnState({
        state: defaultState,
        applyOrder: true,
      });
    }
  };
  const location = useLocation();

  const handleOpenMassEmail = () => {
    navigate('/contacts/massEmailPage', { state: { module: 'Contact' } });
  };
  const exportAll = async () => {
    setLoading(true);

    const fetchData = {
      ...contactInputData,
      pageSize: gridData?.totalCount,
      searchText: gridData?.inputPayload?.searchText ? gridData?.inputPayload?.searchText : null,
      filterJson: gridData?.inputPayload?.filterJson ? gridData?.inputPayload?.filterJson : null,
    };

    try {
      const response = await apiServices.exportAllContact(fetchData);

      if (response?.data && response.status === 200) {
        setLoading(false);
        if (response?.data.includes('Export initiated.')) {
          toast.warning(response?.data); // Show toast
          setLoading(false);
        } else {
          // Convert data to Blob for better handling
          const blob = new Blob([response.data], {
            type: 'text/csv;charset=utf-8;',
          });
          const url = URL.createObjectURL(blob);

          // Create and trigger download
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'Contacts.csv');
          document.body.appendChild(link);
          link.click();

          // Cleanup
          document.body.removeChild(link);
          URL.revokeObjectURL(url); // Free memory
        }
      } else {
        console.error('No data received from API.');
        setLoading(false);
      }
    } catch (error) {
      console.error('Error exporting Contacts:', error);
      setLoading(false);
    }
  };
  const handleOpenManageTag = () => {
    navigate('/contacts/manageTags', {
      state: { module: 'contactList', moduleApi: 'Contact' },
    });
  };

  const {
    options: campaignList,
    isLoading: isCampaignLoading,
    handleSearch: handleCampaignSearch,
    handleScroll: handleCampaignScroll,
  } = PaginatedDropdown({
    fetchFn: apiServices.getCampaignDropdown,
    responseKey: 'campaignList',
    module: 'Contact',
  });

  useEffect(() => {
    setLoading(storeLoading);
  }, [storeLoading]);

  useEffect(() => {
    const gridApi = gridRef?.current?.api;
    if (gridApi && tagsList?.length > 0) {
      const tagFilterInstance = gridApi.getFilterInstance('tagIds');
      if (tagFilterInstance) {
        const newTagValues = tagsList.map((item) => item.name);
        tagFilterInstance.setFilterValues(newTagValues);
      }
    }
  }, [tagsList]);

  useEffect(() => {
    const plannedOption = memberStatus?.find((option) => option.displayName === 'Planned');

    if (plannedOption) {
      setSelectedOptions((prevState) => ({
        ...prevState,
        memberStatusId: plannedOption.id,
      }));

      setCampaignData((prevState) => ({
        ...prevState,
        memberStatus: plannedOption.id,
        memberStatusId: plannedOption.displayName,
      }));
    }
  }, [memberStatus]);

  useEffect(() => {
    if (!formData?.reminder) {
      setShowReminderPage(false);
      setFormData((prev) => ({
        ...prev,
        showReminder: false,
      }));
    }
  }, [formData?.reminder]);

  useEffect(() => {
    // Check if userInfo exists and if the owner field hasn't been set yet.
    if (userInfo && userInfo?.user?.userId && !formData.owner) {
      // Update formData with the userInfo.userId.
      setFormData((prevData) => ({
        ...prevData,
        owner: userInfo?.user?.display_name,
        ownerId: userInfo?.user?.userId,
      }));
    }
  }, [remindVisible, userInfo, formData.owner]);

  // Restore selection on rowData change
  useEffect(() => {
    const gridApi = gridParams?.api;
    if (!gridApi || !gridData?.inputPayload?.pageNumber) return;

    const pageKey = 'page-' + gridData.inputPayload.pageNumber;
    const selectedRowsDefault = gridDataSelection?.contactList?.[pageKey] || [];

    if (selectedRowsDefault.length > 0) {
      gridApi.forEachNode((node) => {
        const isSelected = selectedRowsDefault.some((row) => row.id === node.data?.id);
        node.setSelected(isSelected);
      });
    } else {
      gridApi.deselectAll(); // Optional: clear selection
    }
  }, [gridParams, rowData, location.pathname]);

  useEffect(() => {
    if (
      gridRef.current?.api &&
      gridData?.contacts?.length &&
      (campaignListDropdown?.length || tagsList?.length) &&
      gridData?.inputPayload?.filterJson
    ) {
      try {
        // Parse filterJson
        const filterJson = JSON.parse(gridData.inputPayload.filterJson);

        // Extract campaign IDs
        const campaignIds = filterJson?.campaignId?.conditions
          ? filterJson.campaignId.conditions.map((condition) => condition.filter)
          : filterJson?.campaignId?.filter
            ? [filterJson.campaignId.filter]
            : [];

        // Extract tag IDs
        const tagIds = filterJson?.tagIds?.conditions
          ? filterJson.tagIds.conditions.map((condition) => condition.filter)
          : filterJson?.tagIds?.filter
            ? [filterJson.tagIds.filter]
            : [];
        // setFilterJson(filterJson);
        console.log('Extracted Campaign IDs:', campaignIds);
        console.log('Extracted Tag IDs:', tagIds);

        // Create a mapping of campaignId -> campaignName
        const campaignMapping = campaignListDropdown.reduce((acc, campaign) => {
          acc[campaign.id] = campaign.campaignName;
          return acc;
        }, {});

        // Create a mapping of tagId -> tagName
        const tagMapping = tagsList.reduce((acc, tag) => {
          acc[tag.id] = tag.name;
          return acc;
        }, {});

        // Get campaign names from matched IDs
        const matchedCampaignNames = campaignIds.map(
          (id) => campaignMapping[id] || 'Unknown Campaign'
        );

        // Get tag names from matched IDs (flattened)
        const matchedTagNames = tagIds.map((id) => tagMapping[id] || 'Unknown Tag').flat();

        console.log('Matched Campaign Names:', matchedCampaignNames);
        console.log('Matched Tag Names:', matchedTagNames);

        // Update contacts with campaignName and tags
        const updatedContacts = gridData.contacts.map((contact) => ({
          ...contact,
          campaignName: matchedCampaignNames, // Correct format
          tags: matchedTagNames, // Flattened array
        }));

        // Remove duplicate contacts based on `id`
        const uniqueContacts = updatedContacts.filter(
          (contact, index, self) => index === self.findIndex((c) => c.id === contact.id)
        );

        // Update grid data
        const updatedGridData = {
          ...gridData,
          contacts: uniqueContacts,
        };
        console.log('🚀 ~ useEffect ~ updatedGridData:', updatedGridData);

        // Update the grid with new data
        gridRef.current.api.setGridOption('rowData', updatedGridData.contacts);
        gridRef.current.api.refreshCells();
      } catch (error) {
        console.error('Error parsing filterJson:', error);
      }
    }
  }, [gridData, campaignListDropdown, tagsList]);

  useFetchIfNeeded(getContactList, fetchDataAndUpdateStore, {
    key: 'contactList',
    inputData: contactInputData,
  });

  useFetchIfNeeded(getCampaignDropdownContact, fetchDataAndUpdateStore, {
    key: 'campaignDropdownContact',
    inputData: dropdownPayloadCampaignContact,
  });

  useFetchIfNeeded(getTagsByModule('contactList'), fetchDataAndUpdateStore, {
    key: 'tagsByModule',
    inputData: 'Contact',
    storeKey: 'contactList',
  });

  return (
    <div className={`inner-page gos-leads gos-contacts${hasActiveFilters ? ' has-filterbar' : ''}`} style={containerStyle}>
      <div className="dash-container">
        <div className="tbl_container">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12">
              {/* GrowthOS header — persists; selection actions render in the toolbar bulk-bar below */}
              <div className="main-hd">
                <div className="gos-lead-head">
                  <div className="pagetitle">Contacts</div>
                  {gridData?.totalCount !== undefined && (
                    <div className="gos-page-sub">{Number(gridData.totalCount).toLocaleString()} contacts</div>
                  )}
                </div>

                <div className="third-div gos-lead-actions">
                  {hasCreateContactPermission && (
                    <button type="button" className="gos-btn gos-btn-ghost" onClick={() => setImportOpen(true)}>
                      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M12 21V9M7 14l5-5 5 5M5 3h14" /></svg>
                      Import
                    </button>
                  )}
                  <button type="button" className="gos-btn gos-btn-ghost" onClick={exportAll}>
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3v12M7 10l5 5 5-5M5 21h14" /></svg>
                    Export
                  </button>
                  {hasCreateContactPermission && (
                    <button type="button" className="gos-btn gos-btn-primary" onClick={handleOpenAddForm}>
                      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M12 5v14M5 12h14" /></svg>
                      New Contact
                    </button>
                  )}
                  <div className="dropdown gos-more">
                    <button type="button" className="gos-btn-icon" id="contactsMoreMenu" data-bs-toggle="dropdown" aria-expanded="false" aria-label="More options" title="More options">
                      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h.01M12 12h.01M19 12h.01" /></svg>
                    </button>
                    <ul className="dropdown-menu dropdown-menu-end gos-more-menu" aria-labelledby="contactsMoreMenu">
                      <li>
                        <button type="button" className="dropdown-item gos-more-item" onClick={handleOpenMassEmail}>
                          <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2ZM22 7l-10 6L2 7" /></svg>
                          Mass Email
                        </button>
                      </li>
                      <li>
                        <button type="button" className="dropdown-item gos-more-item" onClick={handleOpenManageTag}>
                          <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12V3h9l9 9-9 9-9-9ZM7.5 7.5h.01" /></svg>
                          Manage Tags
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* toolbar: bulk-bar when rows are selected, else search + count */}
              {fullSelection.length > 0 ? (
                <div className="gos-lead-toolbar bulk-bar">
                  <div className="bulk-left">
                    <button type="button" className="bulk-clear" onClick={clearContactSelection} title="Clear selection">
                      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18M6 6l12 12" /></svg>
                    </button>
                    <span className="bulk-count">{fullSelection.length} selected</span>
                  </div>
                  <div className="bulk-right">
                    {hasUpdateContactPermission && (
                      <button type="button" className="gos-btn gos-btn-ghost gos-btn-sm" onClick={() => setTicketOpen(true)}>
                        <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M4 13l2.5-8h11L20 13M4 13v6a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-6M4 13h5l1 2h4l1-2h5" /></svg>
                        Create Ticket
                      </button>
                    )}
                    {hasUpdateContactPermission && (
                      <div className="dropdown gos-bulk-dd">
                        <button type="button" className="gos-btn gos-btn-ghost gos-btn-sm" data-bs-toggle="dropdown" aria-expanded="false">
                          <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12V3h9l9 9-9 9-9-9ZM7.5 7.5h.01" /></svg>
                          Tags
                          <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9l6 6 6-6" /></svg>
                        </button>
                        <ul className="dropdown-menu gos-more-menu">
                          <li><button type="button" className="dropdown-item gos-more-item" onClick={handleAddTag}>Add Tags</button></li>
                          <li><button type="button" className="dropdown-item gos-more-item" onClick={handleRemoveTag}>Remove Tags</button></li>
                        </ul>
                      </div>
                    )}
                    <div className="dropdown gos-bulk-dd">
                      <button type="button" className="gos-btn gos-btn-primary gos-btn-sm" data-bs-toggle="dropdown" aria-expanded="false">
                        Actions
                        <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9l6 6 6-6" /></svg>
                      </button>
                      <ul className="dropdown-menu dropdown-menu-end gos-more-menu">
                        {hasUpdateContactPermission && (
                          <li>
                            <button type="button" className="dropdown-item gos-more-item" onClick={() => setMassUpdateOpen(true)}>
                              <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5Z" /></svg>
                              Mass Update
                            </button>
                          </li>
                        )}
                        {hasUpdateContactPermission && (
                          <li>
                            <button type="button" className="dropdown-item gos-more-item" onClick={() => setChangeOwnerOpen(true)}>
                              <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12a9 9 0 1 1-3-6.7L21 8M21 3v5h-5" /></svg>
                              Change Owner
                            </button>
                          </li>
                        )}
                        {hasUpdateContactPermission && (
                          <li>
                            <button type="button" className="dropdown-item gos-more-item" onClick={() => setAddCampaignOpen(true)}>
                              <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M3 11v2a1 1 0 0 0 1 1h2l4 4V6L6 10H4a1 1 0 0 0-1 1ZM15 8a4 4 0 0 1 0 8M18 5a8 8 0 0 1 0 14" /></svg>
                              Add to Campaign
                            </button>
                          </li>
                        )}
                        {hasDeleteContactPermission && (
                          <li>
                            <button type="button" className="dropdown-item gos-more-item danger has-sep" data-bs-toggle="modal" data-bs-target="#delete">
                              <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2m2 0v14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V6h12M10 11v6M14 11v6" /></svg>
                              Delete
                            </button>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="gos-lead-toolbar">
                  <div className="gos-lead-toolbar-left">
                    <div className="gos-lead-toolbar-search">
                      <GlobalSearch
                        moduleName={'contactList'}
                        fullSelection={fullSelection}
                        placeholder="Search by name, company or email…"
                      />
                    </div>
                    {gridData?.totalCount !== undefined && (
                      <span className="result-count">
                        <strong>{Number(gridData.totalCount).toLocaleString()}</strong>{' '}
                        {gridData?.inputPayload?.searchText ? 'matches' : 'contacts'}
                      </span>
                    )}
                  </div>
                  <div className="gos-lead-toolbar-right">
                    <LeadsFilters
                      fields={filterFields}
                      conds={filterConds}
                      setCond={setFilterCond}
                      removeCond={removeFilterCond}
                      clearAll={clearAllFilters}
                      onApply={applyFilterConds}
                      expanded={expandedFilter}
                      setExpanded={setExpandedFilter}
                      open={filterOpen}
                      setOpen={setFilterOpen}
                    />
                    <LeadsColumns
                      columns={columnMenuList}
                      hidden={hiddenCols}
                      onToggle={toggleCol}
                      onToggleAll={toggleAllCols}
                      open={colsOpen}
                      setOpen={setColsOpen}
                    />
                  </div>
                </div>
              )}
              {fullSelection.length === 0 && (
                <ActiveFilterBar
                  fields={filterFields}
                  conds={filterConds}
                  onEdit={(f) => {
                    setExpandedFilter(f);
                    setFilterOpen(true);
                  }}
                  onRemove={removeFilterCond}
                  onClear={clearAllFilters}
                />
              )}

              <div className="cutome_ag_theme">
                <div
                  className={`ag-theme-balham tbl_height`}
                  style={{ width: '100%', height: `100%` }}
                >
                  <AgGridReact
                    className="ag-grid-container"
                    domLayout="fixedHeight"
                    ref={gridRef}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    autoGroupColumnDef={autoGroupColumnDef}
                    defaultColDef={defaultColDef}
                    overlayLoadingTemplate={`<Loader />`}
                    animateRows={true}
                    rowSelection={'multiple'}
                    rowHeight={64}
                    headerHeight={44}
                    // statusBar={statusBar}
                    sideBar={false}
                    enableRangeSelection={true}
                    suppressExcelExport={true}
                    suppressRowClickSelection={true}
                    groupSelectsChildren={true}
                    pivotPanelShow={'never'}
                    popupParent={popupParent}
                    onSelectionChanged={onSelectionChanged}
                    sortingOrder={sortingOrder}
                    onFirstDataRendered={onFirstDataRendered}
                    onCellClicked={cellClickedListener}
                    rowDragManaged={true}
                    suppressMoveWhenRowDragging={true}
                    rowGroupPanelShow={'never'}
                    onFilterChanged={handleFilterChanged}
                    // onGridReady={(params) => setGridParams(params)}
                    onGridReady={handleGridReady}
                    onColumnMoved={handleColumnChanged}
                    onColumnVisible={handleColumnChanged}
                    gridOptions={gridOptions}
                    columnTypes={columnTypes}
                    onSortChanged={handleSortChanged}
                  />
                  {gridParams && (
                    <FilterHandler
                      params={gridParams}
                      gridData={gridData}
                      campaignListDropdown={campaignListDropdown}
                      tagsList={tagsList}
                      columnDefs={columnDefs}
                      filterDefaultSetRef={filterDefaultSetRef}
                    />
                  )}
                </div>
                {loading && <GridSkeleton rows={10} />}
              </div>
            </div>
          </div>
        </div>
        {showMassEmailPopup && (
          <MassEmail
            handleClose={closeMassEmailPopup}
            selectedRows={fullSelection}
            module={'Contact'}
          />
        )}
        {importOpen && <ContactsImportModal onClose={() => setImportOpen(false)} />}
        {ticketOpen && (
          <ContactsCreateTicketModal
            onClose={() => setTicketOpen(false)}
            contactIds={fullSelection.map((c) => c.id)}
            priorities={ticketPriorityDropdown}
            statuses={ticketStatusDropdown}
            owners={owner}
            defaultOwnerId={userInfo?.user?.userId || userInfo?.userId}
            onCreated={clearContactSelection}
          />
        )}
        {massUpdateOpen && (
          <ContactsMassUpdateModal
            onClose={() => setMassUpdateOpen(false)}
            contactIds={fullSelection.map((c) => c.id)}
            fields={allcolumnList}
            onUpdated={() => {
              dispatch(
                fetchDataAndUpdateStore({
                  key: 'contactList',
                  inputData: gridData?.inputPayload ? gridData?.inputPayload : contactInputData,
                })
              );
              dispatch(fetchDataAndUpdateStore({ key: 'contactDropdown', inputData: dropdownPayload }));
              clearContactSelection();
            }}
          />
        )}
        {changeOwnerOpen && (
          <ContactsChangeOwnerModal
            onClose={() => setChangeOwnerOpen(false)}
            contactIds={fullSelection.map((c) => c.id)}
            owners={owner}
            onUpdated={() => {
              dispatch(
                fetchDataAndUpdateStore({
                  key: 'contactList',
                  inputData: gridData?.inputPayload ? gridData?.inputPayload : contactInputData,
                })
              );
              clearContactSelection();
            }}
          />
        )}
        {addCampaignOpen && (
          <ContactsAddCampaignModal
            onClose={() => setAddCampaignOpen(false)}
            contactIds={fullSelection.map((c) => c.id)}
            campaigns={campaignList}
            memberStatuses={memberStatus}
            onSearch={handleCampaignSearch}
            isLoading={isCampaignLoading}
            onAdded={clearContactSelection}
          />
        )}
      </div>

      <ChildTicket
        remindVisible={remindVisible}
        showReminderPage={showReminderPage}
        handleBackClick={handleBackClick}
        togglePopupVisibility={togglePopupVisibility}
        formData={formData}
        handleDateTime={handleDateTime}
        handleChangeForm={handleChangeForm}
        errormsg={errormsg}
        handleChange={handleChange}
        selectedOptions={selectedOptions}
        ticketPriorityDropdown={ticketPriorityDropdown}
        owner={owner}
        ticketStatusDropdown={ticketStatusDropdown}
        handleReminderClick={handleReminderClick}
        loading={loading}
        handleFormSubmit={handleFormSubmit}
      />

      {/* Popup Modal */}
      {showPopup && (
        <div id="genricPopup">
          <div className="popup-overlay">
            <div className="popup">
              <div className="popup-header">
                <h2>{popupAction === 'add' ? 'Add Tags' : 'Remove Tags'}</h2>
                <button
                  type="button"
                  className="custom-btn-close"
                  aria-label="Close"
                  onClick={togglePopup}
                ></button>
              </div>

              {popupAction === 'add' ? (
                <Tags
                  module="Contact"
                  handleClose={togglePopup}
                  selectedRows={fullSelection}
                  storeKey={'contactList'}
                />
              ) : (
                <Tags
                  module="Contact"
                  removeMode={true}
                  handleClose={togglePopup}
                  selectedRows={fullSelection}
                  storeKey={'contactList'}
                />
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal structure Mass Update */}
      <div id="dropdown_modal">
        <div
          className="modal fade"
          id="myModal"
          tabIndex="-1"
          aria-labelledby="modalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog ">
            <div className="modal-content">
              <div className="modal-header" style={{ padding: '1rem 1.6rem' }}>
                <h5 className="modal-title" id="modalLabel">
                  Mass Update
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12 col-md-6">
                    <div className="input-container">
                      <label htmlFor="timeZoneId">Field</label>
                      <Select
                        value={isSelectedOption ? selectedOption : null}
                        options={allcolumnList?.map((data) => ({
                          value: data.field,
                          label: data.headerName,
                          originalData: data,
                        }))}
                        onChange={(selectedOption) => handleSelection(selectedOption)}
                        menuShouldScrollIntoView={false}
                        disabled={'timeZoneId'}
                        placeholder={'Select Field'}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            borderRadius: '5px',
                            borderColor: state.isFocused ? '#365397' : base.borderColor,
                            boxShadow: state.isFocused ? '0 0 0 1px #365397' : base.boxShadow,
                          }),
                          menu: (base) => ({
                            ...base,
                            borderRadius: '5px',
                            zIndex: 99999,
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                          option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isSelected
                              ? 'rgba(54, 83, 151, 0.3)'
                              : state.isFocused
                                ? '#365397'
                                : base.backgroundColor,
                            color: state.isSelected
                              ? '#fff'
                              : state.isFocused
                                ? '#fff'
                                : base.color,
                            cursor: 'pointer',
                          }),
                        }}
                        menuPortalTarget={document.body}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="input-container massInput">
                      {selectedOption && isSelectedOption ? (
                        selectedOption.originalData.type === 'text' ? (
                          <input
                            type="text"
                            placeholder={`Enter ${selectedOption.label}`}
                            value={fieldValues[selectedOption.value] || ''}
                            onChange={(e) => handleInputChange(e, selectedOption.value)}
                            style={{
                              width: '100%',
                              height: '40px',
                              borderRadius: '5px',
                              border: '1px solid #ccc', // Matches Select border color
                              padding: '8px 12px', // Matches Select padding
                              marginTop: '14px',
                              fontSize: '16px',
                              outline: 'none',
                              transition: 'border-color 0.3s, box-shadow 0.3s',
                            }}
                            onFocus={(e) => {
                              e.target.style.borderColor = '#365397'; // Focus border color
                              e.target.style.boxShadow = '0 0 0 1px #365397'; // Focus box-shadow
                            }}
                            onBlur={(e) => {
                              e.target.style.borderColor = '#ccc'; // Reset border color on blur
                              e.target.style.boxShadow = 'none'; // Remove box-shadow on blur
                            }}
                          />
                        ) : selectedOption.originalData.type === 'dropdown' ? (
                          selectedOption.originalData.headerName === 'Account Name' ? (
                            <SelectBox
                              name={'accountId'}
                              placeholder={'Select Account Name'}
                              selectedOptions={selectedOptions?.accountId}
                              handleSelect={handleDropdownChange}
                              options={accountOptions}
                              optionKeys={['id', 'name']}
                              errormsg={errormsg?.accountId}
                              isLoading={isAccountLoading}
                              onSearch={handleAccountSearch}
                              onScrollToBottom={handleAccountScroll}
                              fieldType={'accountId'}
                              fieldId={formData?.accountId}
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  borderRadius: '5px',
                                  marginTop: '14px',
                                  borderColor: state.isFocused ? '#365397' : base.borderColor,
                                  boxShadow: state.isFocused ? '0 0 0 1px #365397' : base.boxShadow,
                                }),
                                menu: (base) => ({
                                  ...base,
                                  borderRadius: '5px',
                                  zIndex: 99999,
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 99999,
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: state.isFocused
                                    ? '#365397'
                                    : base.backgroundColor,
                                  color: state.isFocused ? '#fff' : base.color,
                                  cursor: 'pointer',
                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  padding: '2px 4px',
                                  borderRadius: '3px',
                                }),
                              }}
                            />
                          ) : (
                            <Select
                              value={
                                fieldValues[`${selectedOption?.value}Id`]
                                  ? (() => {
                                      const selectedValue =
                                        fieldValues[`${selectedOption?.value}Id`];
                                      const foundData = selectedOption.originalData.data?.find(
                                        (data) =>
                                          data.id === selectedValue ||
                                          (data.userId && data.userId === selectedValue)
                                      );
                                      return {
                                        value: selectedValue,
                                        label:
                                          foundData?.displayName ||
                                          foundData?.display_name ||
                                          foundData?.name ||
                                          '',
                                      };
                                    })()
                                  : null
                              }
                              options={
                                selectedOption.originalData.data?.map((data) => ({
                                  value: data.id ? data.id : data.userId,
                                  label: data.displayName
                                    ? data.displayName
                                    : data.display_name
                                      ? data.display_name
                                      : data.name,
                                })) || []
                              }
                              disabled
                              placeholder={`Select ${selectedOption.label}`}
                              menuPortalTarget={document.body} // Ensures the dropdown renders outside the modal
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  borderRadius: '5px',
                                  marginTop: '14px',
                                  borderColor: state.isFocused ? '#365397' : base.borderColor,
                                  boxShadow: state.isFocused ? '0 0 0 1px #365397' : base.boxShadow,
                                }),
                                menu: (base) => ({
                                  ...base,
                                  borderRadius: '5px',
                                  zIndex: 99999,
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 99999,
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: state.isFocused
                                    ? '#365397'
                                    : base.backgroundColor,
                                  color: state.isFocused ? '#fff' : base.color,
                                  cursor: 'pointer',
                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  padding: '2px 4px',
                                  borderRadius: '3px',
                                }),
                              }}
                              onChange={(selected) =>
                                handleDropdownChange(selected, `${selectedOption.value}Id`)
                              }
                            />
                          )
                        ) : selectedOption.originalData.type === 'number' ? (
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              marginTop: '14px',
                              position: 'relative',
                            }}
                          >
                            {selectedOption.originalData.headerName === 'Annual Revenue' && (
                              <div
                                style={{
                                  position: 'relative',
                                  width: '100%',
                                }}
                              >
                                <span
                                  style={{
                                    position: 'absolute',
                                    left: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    fontSize: '16px',
                                    color: '#888',
                                    pointerEvents: 'none',
                                  }}
                                >
                                  $
                                </span>
                                <input
                                  type="number"
                                  placeholder={`Enter ${selectedOption.label}`}
                                  value={fieldValues[selectedOption.value] || ''}
                                  onChange={(e) => {
                                    // Enforce number limit conditionally for "Mobile"
                                    const value = e.target.value;
                                    if (
                                      selectedOption.originalData.headerName === 'Mobile' &&
                                      value.length > 15
                                    ) {
                                      return; // Prevent further input if length exceeds limit
                                    }
                                    handleInputChange(e, selectedOption.value); // Call your change handler
                                  }}
                                  style={{
                                    width: '100%',
                                    height: '40px',
                                    borderRadius: '5px',
                                    border: '1px solid #ccc',
                                    padding: '8px 12px 8px 30px', // Add padding-left to account for the dollar symbol
                                    fontSize: '16px',
                                    outline: 'none',
                                    transition: 'border-color 0.3s, box-shadow 0.3s',
                                  }}
                                  onFocus={(e) => {
                                    e.target.style.borderColor = '#365397';
                                    e.target.style.boxShadow = '0 0 0 1px #365397';
                                  }}
                                  onBlur={(e) => {
                                    e.target.style.borderColor = '#ccc';
                                    e.target.style.boxShadow = 'none';
                                  }}
                                />
                              </div>
                            )}
                            {/* Input without the dollar sign for other cases */}
                            {selectedOption.originalData.headerName !== 'Annual Revenue' && (
                              <input
                                type="number"
                                placeholder={`Enter ${selectedOption.label}`}
                                value={fieldValues[selectedOption.value] || ''}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (
                                    selectedOption.originalData.headerName === 'Mobile' &&
                                    value.length > 15
                                  ) {
                                    return;
                                  }
                                  handleInputChange(e, selectedOption.value);
                                }}
                                style={{
                                  width: '100%',
                                  height: '40px',
                                  borderRadius: '5px',
                                  border: '1px solid #ccc',
                                  padding: '8px 12px',
                                  fontSize: '16px',
                                  outline: 'none',
                                  transition: 'border-color 0.3s, box-shadow 0.3s',
                                }}
                                onFocus={(e) => {
                                  e.target.style.borderColor = '#365397';
                                  e.target.style.boxShadow = '0 0 0 1px #365397';
                                }}
                                onBlur={(e) => {
                                  e.target.style.borderColor = '#ccc';
                                  e.target.style.boxShadow = 'none';
                                }}
                              />
                            )}
                          </div>
                        ) : selectedOption.originalData.type === 'checkbox' ? (
                          <div className="input-container" id="flex-clumn">
                            <span>Email Opt Out</span>
                            <input
                              type="checkbox"
                              label={'Email Opt Out'}
                              name={'emailOptOut'}
                              onChange={handleChangeCheckbox}
                            />
                          </div>
                        ) : (
                          <></>
                        )
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="cancel_popup"
                  id="massUpdateCancel"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="save_popup"
                  onClick={() => handleMassUpdate(fullSelection)}
                  disabled={loading}
                >
                  Submit
                  {loading && (
                    <span
                      className="spinner-border spinner-border-sm ms-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal structure Change Owner */}
      <div id="dropdown_modal">
        <div
          className="modal fade"
          id="myOwner"
          tabIndex="-1"
          aria-labelledby="modalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header" style={{ padding: '1rem 1.6rem' }}>
                <h5 className="modal-title" id="modalLabel">
                  Change Owner
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12 col-md-6" id="ownermodal">
                    <div className="input-container">
                      <label htmlFor="timeZoneId">Contacts Owner</label>
                      <Select
                        options={owner?.map((data) => ({
                          value: data.userId,
                          label: data.display_name,
                        }))}
                        menuShouldScrollIntoView={false}
                        placeholder={'Select Owner'}
                        onChange={handleSelectChange}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            borderRadius: '5px',
                            borderColor: state.isFocused ? '#365397' : base.borderColor,
                            boxShadow: state.isFocused ? '0 0 0 1px #365397' : base.boxShadow,
                          }),
                          menu: (base) => ({
                            ...base,
                            borderRadius: '5px',
                            zIndex: 99999,
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                          option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isSelected
                              ? 'rgba(54, 83, 151, 0.3)'
                              : state.isFocused
                                ? '#365397'
                                : base.backgroundColor,
                            color: state.isSelected
                              ? '#fff'
                              : state.isFocused
                                ? '#fff'
                                : base.color,
                            cursor: 'pointer',
                          }),
                        }}
                        menuPortalTarget={document.body}
                        components={{
                          DropdownIndicator: (props) => (
                            <div
                              {...props.innerProps}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M16.3334 18.25V16.4167C16.3334 15.4442 15.9471 14.5116 15.2595 13.8239C14.5718 13.1363 13.6392 12.75 12.6667 12.75H5.33341C4.36095 12.75 3.42832 13.1363 2.74069 13.8239C2.05306 14.5116 1.66675 15.4442 1.66675 16.4167V18.25M12.6667 5.41667C12.6667 7.44171 11.0251 9.08333 9.00008 9.08333C6.97504 9.08333 5.33341 7.44171 5.33341 5.41667C5.33341 3.39162 6.97504 1.75 9.00008 1.75C11.0251 1.75 12.6667 3.39162 12.6667 5.41667Z"
                                  stroke="#9B9B9B"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </div>
                          ),
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer justify-content-end">
                <button
                  type="button"
                  className="cancel_popup"
                  data-bs-dismiss="modal"
                  id="ownerUpdateCancel"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="save_popup "
                  onClick={() => handleOwnerUpdate(fullSelection)}
                  disabled={loading}
                >
                  {loading && (
                    <span
                      className="spinner-border spinner-border-sm ms-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}
                  Change Owner
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Modal structure Add To Campaigns */}
      <div id="dropdown_modal">
        <div
          className="modal fade"
          id="existing"
          tabIndex="-1"
          aria-labelledby="modalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header" style={{ padding: '1rem 1.6rem' }}>
                <h5 className="modal-title" id="modalLabel">
                  Add to Campaigns
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  id="closeModalButton"
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12 col-md-6" id="myexisting">
                    <div className="input-container">
                      <SelectBox
                        label={'Assign Campaign'}
                        name={'campaignId'}
                        placeholder={'Campaign Source'}
                        // isRequired={true}
                        selectedOptions={selectedOptions?.campaignId}
                        handleSelect={handleChange}
                        options={campaignList}
                        optionKeys={['id', 'campaignName']}
                        errormsg={errormsg?.campaignId}
                        isLoading={isCampaignLoading}
                        onSearch={handleCampaignSearch}
                        onScrollToBottom={handleCampaignScroll}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            borderRadius: '5px',
                            borderColor: state.isFocused ? '#365397' : base.borderColor,
                            borderWidth: state.isFocused ? '1px' : base.borderWidth,
                            boxShadow: state.isFocused ? '0 0 5px rgba(0, 86, 179, 0.3)' : 'none',
                            transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
                            '&:hover': {
                              borderColor: '#365397',
                            },
                          }),
                          menu: (base) => ({
                            ...base,
                            borderRadius: '5px',
                            zIndex: 99999,
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                          option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isSelected
                              ? 'rgba(54, 83, 151, 0.3)'
                              : state.isFocused
                                ? '#365397'
                                : base.backgroundColor,
                            color: state.isSelected
                              ? '#fff'
                              : state.isFocused
                                ? '#fff'
                                : base.color,
                            cursor: 'pointer',
                          }),
                        }}
                        menuPortalTarget={document.body}
                        components={{
                          DropdownIndicator: (props) => (
                            <div
                              {...props.innerProps}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              <svg
                                width="20"
                                height="16"
                                viewBox="0 0 20 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M0.694444 3.83398C0.310926 3.83398 0 4.12572 0 4.48556V9.5713C0 9.93114 0.310926 10.2229 0.694444 10.2229C1.07796 10.2229 1.38889 9.93114 1.38889 9.5713V4.48556C1.38889 4.12572 1.07796 3.83398 0.694444 3.83398Z"
                                  fill="#9B9B9B"
                                />
                                <path
                                  d="M14.0917 0.222656H11.4687C11.1205 0.222656 10.8382 0.504721 10.8382 0.85264V1.42173L2.39558 3.92343C2.12793 4.00273 1.94434 4.2485 1.94434 4.52738V9.44226C1.94417 9.47375 1.9472 9.50551 1.95191 9.53734C1.95275 9.54322 1.95359 9.5491 1.9546 9.5549C1.95931 9.58094 1.96502 9.60698 1.97318 9.63285L3.7604 15.3363C3.84479 15.6057 4.09353 15.7782 4.36185 15.7782C4.42414 15.7782 4.48752 15.7689 4.55015 15.7493L7.15276 14.9361C7.31239 14.8862 7.44563 14.775 7.52313 14.627C7.60072 14.479 7.61619 14.3062 7.56626 14.1467L6.68059 11.3186L10.8382 12.5508V13.1198C10.8382 13.4678 11.1204 13.7498 11.4686 13.7498H14.0917C14.4398 13.7498 14.7221 13.4678 14.7221 13.1198V0.85264C14.7222 0.504721 14.4399 0.222656 14.0917 0.222656ZM6.17463 13.9216L4.77535 14.3588L3.53007 10.3848L5.22423 10.8869L6.17463 13.9216ZM5.90841 9.77556C5.90664 9.77506 5.90479 9.77447 5.90303 9.77396L3.20534 8.97439V4.99768L10.8383 2.73595V11.2367L5.90841 9.77556ZM13.4613 12.4899H12.0992V12.0806V1.89203V1.48271H13.4613V12.4899Z"
                                  fill="#9B9B9B"
                                />
                                <path
                                  d="M19.0799 10.4739L16.2306 9.17481C15.9052 9.02664 15.5097 9.14663 15.347 9.44328C15.1843 9.73985 15.3162 10.1005 15.6415 10.2488L18.4908 11.5479C18.5854 11.591 18.6858 11.6113 18.7849 11.6113C19.0264 11.6113 19.259 11.4897 19.3744 11.2794C19.537 10.9828 19.4051 10.6222 19.0799 10.4739Z"
                                  fill="#9B9B9B"
                                />
                                <path
                                  d="M15.9365 4.94575C16.0355 4.94575 16.136 4.92307 16.2305 4.87513L19.0798 3.43184C19.4051 3.26702 19.537 2.86642 19.3743 2.53688C19.2117 2.20735 18.8161 2.07375 18.4909 2.23857L15.6415 3.68186C15.3162 3.84667 15.1843 4.24727 15.347 4.57681C15.4624 4.81064 15.695 4.94575 15.9365 4.94575Z"
                                  fill="#9B9B9B"
                                />
                                <path
                                  d="M19.3564 6.33398H17.032C16.6767 6.33398 16.3887 6.64491 16.3887 7.02843C16.3887 7.41195 16.6767 7.72287 17.032 7.72287H19.3564C19.7117 7.72287 19.9998 7.41195 19.9998 7.02843C19.9998 6.64482 19.7117 6.33398 19.3564 6.33398Z"
                                  fill="#9B9B9B"
                                />
                              </svg>
                            </div>
                          ),
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-12 col-md-6">
                    <div className="input-container">
                      <label htmlFor="timeZoneId">Select Member Status</label>
                      <Select
                        value={selectedOptions?.memberStatus}
                        placeholder={campaignData?.memberStatusId}
                        onChange={(selectedOption) =>
                          handleChange(selectedOption, 'memberStatusId')
                        }
                        options={memberStatus?.map((data) => ({
                          value: data.id,
                          label: data.displayName,
                        }))}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            borderRadius: '5px',
                            borderColor: state.isFocused ? '#365397' : base.borderColor,
                            borderWidth: state.isFocused ? '1px' : base.borderWidth,
                            boxShadow: state.isFocused ? '0 0 5px rgba(0, 86, 179, 0.3)' : 'none',
                            transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
                            '&:hover': {
                              borderColor: '#365397',
                            },
                          }),
                          menu: (base) => ({
                            ...base,
                            borderRadius: '5px',
                            zIndex: 99999,
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                          option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isSelected
                              ? 'rgba(54, 83, 151, 0.3)'
                              : state.isFocused
                                ? '#365397'
                                : base.backgroundColor,
                            color: state.isSelected
                              ? '#fff'
                              : state.isFocused
                                ? '#fff'
                                : base.color,
                            cursor: 'pointer',
                          }),
                        }}
                        menuPortalTarget={document.body}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer justify-content-end">
                <button type="button" className="cancel_popup" data-bs-dismiss="modal">
                  Cancel
                </button>
                <button
                  type="button"
                  className="save_popup "
                  onClick={() => handleSubmit(campaignData)}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Modal structure Delete */}
      <div id="dropdown_modal">
        <div
          className="modal fade"
          id="delete"
          tabIndex="-1"
          aria-labelledby="modalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="warning-content">
                <div className="warningOuter">
                  <div className="alertImg">
                    <img src="../assets/images/delete-record.png" alt="Delete Record"></img>
                  </div>
                  <div className="warningText">
                    Are you sure you want to delete the selected record?
                  </div>
                </div>
                <div className="notes">
                  *Note: Any associated Activities, Visits, Drafts will also be Deleted.
                </div>
                <div className="warningBtn mt-2">
                  <Button
                    id="massDeleteModal"
                    variant="secondary"
                    type="button"
                    className="btn"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Button>
                  <Button
                    type="button"
                    variant="danger"
                    className="btn"
                    onClick={handleClickDelete}
                  >
                    Confirm Delete
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Modal structure Email  */}

      <div className={`email-popup ${isOpen ? 'open' : ''} ${isMinimized ? 'minimized' : ''}`}>
        <div className="popup-header border_btm email_hd">
          <h5>New Message</h5>
          <div className="modal_btn_group">
            <button onClick={toggleMinimize} className="minimize-btn">
              <svg
                width="20"
                height="20"
                viewBox="0 0 26 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.5"
                  y="0.5"
                  width="25"
                  height="25"
                  rx="5.5"
                  fill="white"
                  stroke="#9B9B9B"
                />
                <line x1="8" y1="18" x2="19" y2="18" stroke="#9B9B9B" strokeWidth="2" />
              </svg>
            </button>
            <button className="maxmin-btn">
              <svg
                width="20"
                height="20"
                viewBox="0 0 26 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.5"
                  y="0.5"
                  width="25"
                  height="25"
                  rx="5.5"
                  fill="white"
                  stroke="#9B9B9B"
                />
                <path
                  d="M13.7222 12.2778L18 8M18 8H14.3333M18 8V11.6667M11.2778 14.7222L7 19M7 19H10.6667M7 19V15.3333"
                  stroke="#9B9B9B"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>

            <button onClick={emailPopup} className="close-btn">
              <svg
                width="20"
                height="20"
                viewBox="0 0 26 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.5"
                  y="0.5"
                  width="25"
                  height="25"
                  rx="5.5"
                  fill="white"
                  stroke="#9B9B9B"
                />
                <path
                  d="M16.2989 17.6905L13.0093 14.3961L9.7198 17.6905C9.62799 17.7869 9.51786 17.8639 9.39589 17.917C9.27392 17.9702 9.14257 17.9984 9.00957 17.9999C8.87656 18.0015 8.74459 17.9764 8.6214 17.9262C8.49822 17.8759 8.38631 17.8015 8.29225 17.7073C8.1982 17.6131 8.1239 17.5011 8.07372 17.3777C8.02354 17.2543 7.9985 17.1222 8.00007 16.989C8.00164 16.8558 8.02978 16.7242 8.08284 16.6021C8.13591 16.4799 8.21283 16.3696 8.30907 16.2777L11.5986 12.9834L8.30907 9.68902C8.12921 9.50021 8.03024 9.24843 8.03331 8.9875C8.03638 8.72657 8.14125 8.4772 8.32549 8.29268C8.50974 8.10816 8.75875 8.00314 9.0193 8.00007C9.27985 7.997 9.53126 8.09611 9.7198 8.27623L13.0093 11.5706L16.2989 8.27623C16.4874 8.09611 16.7388 7.997 16.9994 8.00007C17.2599 8.00314 17.5089 8.10816 17.6932 8.29268C17.8774 8.4772 17.9823 8.72657 17.9854 8.9875C17.9884 9.24843 17.8895 9.50021 17.7096 9.68902L14.4201 12.9834L17.7096 16.2777C17.8956 16.4656 18 16.7195 18 16.9841C18 17.2487 17.8956 17.5026 17.7096 17.6905C17.6173 17.7839 17.5074 17.8581 17.3862 17.9086C17.265 17.9591 17.135 17.985 17.0037 17.9848C16.8725 17.9846 16.7426 17.9582 16.6216 17.9073C16.5006 17.8563 16.3909 17.7818 16.2989 17.688V17.6905Z"
                  fill="#9B9B9B"
                />
              </svg>
            </button>
          </div>
        </div>

        <div className="popup-body email_body">
          <div className="container_label border_btm">
            <div className="label_nm">
              <svg
                width="16"
                height="16"
                viewBox="0 0 23 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.1668 20.125V18.2083C19.1668 17.1917 18.763 16.2166 18.0441 15.4978C17.3252 14.7789 16.3502 14.375 15.3335 14.375H7.66683C6.65017 14.375 5.67514 14.7789 4.95625 15.4978C4.23736 16.2166 3.8335 17.1917 3.8335 18.2083V20.125M15.3335 6.70833C15.3335 8.82542 13.6173 10.5417 11.5002 10.5417C9.38307 10.5417 7.66683 8.82542 7.66683 6.70833C7.66683 4.59124 9.38307 2.875 11.5002 2.875C13.6173 2.875 15.3335 4.59124 15.3335 6.70833Z"
                  stroke="#9B9B9B"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <div className="label_content">
                <label htmlFor="email">
                  <span
                    style={{
                      fontWeight: 'bold',
                      fontSize: '.8rem',
                    }}
                  >
                    John Doe
                  </span>{' '}
                  <span
                    style={{
                      color: '#666',
                      fontSize: '.8rem',
                    }}
                  >
                    &lt;johndoetest@nomail.com&gt;
                  </span>
                </label>
              </div>
            </div>
            <div className="heading_item" id="insert_template">
              <div className="dropdown">
                <button
                  className=" btn action-btn dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Insert Template
                </button>
                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <li>
                    <Link className="dropdown-item" href="#">
                      Add Template
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="container_label border_btm">
            <div className="label_nm">
              <span> To :</span>

              <div className="label_content">
                <div>
                  <Select
                    isMulti
                    value={selectedOptions}
                    onChange={setSelectedOptions}
                    placeholder="Select options..."
                    styles={customStyles}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="container_label border_btm">
            <div className="label_nm">
              <span>Subject :</span>

              <div className="label_content">
                <div>
                  <Select
                    isMulti
                    value={selectedOptions}
                    onChange={setSelectedOptions}
                    placeholder="Select options..."
                    styles={customStyles}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="popup-footer">
          <div className="email_group">
            <Link className="schedule-btn" type="button">
              <img src={schedule} alt="schedule" />
              Schedule
            </Link>
            <button className="add-btn" type="button">
              Send
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contacts;
